import { makeLabels } from 'utils/i18n';

const NAMESPACE = 'page.pwcOrders.view.sections.order.refund.confirmationModal';
export const LABELS = makeLabels(
  {
    QUESTION: ['question', 'Are you sure?'],
    REMARK: [
      'remark',
      [
        'The refund of <b>{{amountWithCurrency}}</b> will be processed.<br>',
        'An email will be sent to the customer to confirm the refund.',
      ].join(' '),
    ],
    ESTIMATE: [
      'estimate',
      [
        '<br/>Estimated settlement amount: <b>≈ {{settlementAmount}} {{settlementCurrencyCode}}</b>.',
        'Estimated rate: 1 {{settlementCurrencyCode}} ≈ {{displayFxRate}} {{fiatCurrencyCode}}.',
        'The final rate and settlement amount are locked when the refund is created.',
      ].join(' '),
    ],
    ESTIMATE_LOADING: ['estimateLoading', '<br/>Loading settlement estimate…'],
    ESTIMATE_UNAVAILABLE: [
      'estimateUnavailable',
      [
        '<br/>The settlement estimate is currently unavailable.',
        'The final rate and settlement amount will be locked when the refund is created.',
      ].join(' '),
    ],
    ACTIONS: {
      BACK: ['actions.back', 'Back'],
      CONFIRM: ['actions.confirm', 'Confirm'],
    },
  },
  NAMESPACE,
);
